/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { CollabraService } from '@workspaces/utils/collabra.service';

@Injectable()
export class MockCollabraService extends CollabraService implements CollabraService {
  public override getCollabraConnectionUrl(_documentId: string) {
    const driftApi = 'https://dea77bclac.execute-api.us-west-1.amazonaws.com';
    const accessToken = this.cognitoService.authenticationSubject.getValue()?.getIdToken().getJwtToken();
    const generatedWopiUrl = `${driftApi}/wopi/files/37151b4c-c6f3-49a1-a539-b583293b5b7e`;
    const usedCollabora = 'https://d3teh9i6vsekhp.cloudfront.net/browser/c042625181/cool.html';
    return `${usedCollabora}?WOPISrc=${encodeURIComponent(generatedWopiUrl)}&access_token=${accessToken}`;
  }
}
